/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [获取快递网点信息↗](http://yapi.yishou.com/project/128/interface/api/29884) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/WavePicking/senderList`
 */
const senderListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/senderList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_pc"],
        properties: { is_pc: { type: "string", description: "是否pc" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "网点id" },
                        shipping_company: { type: "string", description: "快递公司" },
                        admin_name: { type: "string", description: "管理员名称" },
                        province: { type: "string", description: "省份" },
                        city: { type: "string", description: "城市" },
                        district: { type: "string", description: "地区" },
                        detail: { type: "string", description: "详细地址" },
                        is_warning: { type: "string", description: "是否开启预警{0：没有开启，1：开启预警}" },
                        warning_num: { type: "string", description: "预警面单数量" },
                        cpcode: { type: "string", description: "快递公司编号" },
                        origin: { type: "string", description: "地区{1：广州，2：杭州}" },
                        shipping_sender_is_default: { type: "string", description: "是否默认" },
                    },
                    required: [
                        "id",
                        "shipping_company",
                        "admin_name",
                        "province",
                        "city",
                        "district",
                        "detail",
                        "is_warning",
                        "warning_num",
                        "cpcode",
                        "origin",
                        "shipping_sender_is_default",
                    ],
                },
                description: "快递网点信息",
            },
            origin: { type: "number", description: "地区{1：广州，2：杭州}" },
            shipping_company: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        cpid: { type: "string", description: "快递公司id" },
                        shipping_company: { type: "string", description: "快递公司名称" },
                        telephone: { type: "string", description: "电话" },
                        shipping_name: { type: "string", description: "快递100代号" },
                        kdniao: { type: "string", description: "快递鸟代号" },
                        cniao: { type: "string", description: "快递公司编号" },
                        default_icon: { type: "string", description: "默认图标" },
                        is_mall_use: { type: "string", description: "是否商城可选用{0:不可用,1:可用}" },
                        use_update_admin: { type: "string", description: "商城可用标示修改人" },
                        use_update_time: { type: "string", description: "商城可用标示修改时间" },
                        create_time: { type: "string", description: "创建时间" },
                        update_time: { type: "string", description: "更新时间" },
                    },
                    required: [
                        "cpid",
                        "shipping_company",
                        "telephone",
                        "shipping_name",
                        "kdniao",
                        "cniao",
                        "default_icon",
                        "is_mall_use",
                        "use_update_admin",
                        "use_update_time",
                        "create_time",
                        "update_time",
                    ],
                },
                description: "快递公司信息",
            },
        },
    },
    requestFunctionName: "senderList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取快递网点信息↗](http://yapi.yishou.com/project/128/interface/api/29884) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/WavePicking/senderList`
 */
export const senderList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(senderListRequestConfig, requestData), ...args);
};
senderList.requestConfig = senderListRequestConfig;
/**
 * 接口 [设置面单预警信息↗](http://yapi.yishou.com/project/128/interface/api/29890) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/WavePicking/setWarningNotify`
 */
const setWarningNotifyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/setWarningNotify",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["is_pc", "sender_id", "is_warning", "warning_num"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_pc", "sender_id", "is_warning", "warning_num", "is_pc", "sender_id", "is_warning", "warning_num"],
        properties: {
            is_pc: { type: "string", description: "是否pc登录" },
            sender_id: { type: "string", description: "网点id" },
            is_warning: { type: "string", description: "是否开启预警{0：关闭预警，1：开启预警或修改预警值}" },
            warning_num: { type: "string", description: "设置的预警值" },
        },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "setWarningNotify",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置面单预警信息↗](http://yapi.yishou.com/project/128/interface/api/29890) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/WavePicking/setWarningNotify`
 */
export const setWarningNotify = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setWarningNotifyRequestConfig, requestData), ...args);
};
setWarningNotify.requestConfig = setWarningNotifyRequestConfig;
/**
 * 接口 [PC点货\/拆包 设置↗](http://yapi.yishou.com/project/128/interface/api/29942) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `三方仓支持前置仓`, `爆版4.23.0`, `#2685指定货号不能退换货`, `#2904非我司改标`
 * @请求头 `POST /erp/Work/alertLockScreenSettingSave`
 */
const alertLockScreenSettingSaveRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/alertLockScreenSettingSave",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "db_btn_diabled_num",
            "db_tips_text",
            "db_tips_time",
            "unpack_text",
            "unpack_time",
            "db_package_no_require",
            "pda_receive_package_no_require",
            "take_stock_tip_supply[]",
            "take_stock_tip_msg",
            "old_goods_return_max_day",
            "no_data_reason_no_require",
            "is_pc",
            "is_need_rejects_vessel",
            "is_need_no_data_vessel",
            "container_lock_similar_pack",
            "exchange_max_days",
            "no_return_tips_time",
            "unreason_setting[0][identity]",
            "unreason_setting[0][not_us_goods_num]",
            "unreason_setting[0][involving_supply_num]",
        ],
        properties: {
            db_btn_diabled_num: { type: "string", description: "PC点货出标停留设置: 禁用时间" },
            db_tips_text: { type: "string", description: "PC点货单款进入提示:提示文案" },
            db_tips_time: { type: "string", description: "PC点货单款进入提示:提示时长" },
            unpack_text: { type: "string", description: "售后拆包提示 : 提示文案" },
            unpack_time: { type: "string", description: "售后拆包提示 : 提示时长" },
            db_package_no_require: { type: "string", description: "PC点货包裹号必填设置" },
            pda_receive_package_no_require: { type: "string", description: "PC点货前PDA必须签收" },
            "take_stock_tip_supply[]": { type: "string", description: "PC点货包裹(商家)进入提示: 商家" },
            take_stock_tip_msg: { type: "string", description: "PC点货包裹(商家)进入提示: 提示文案" },
            old_goods_return_max_day: {
                type: "string",
                description: "售后旧货不退换：售后寄回商品距最近采购计划生成时间已超过天数",
            },
            no_data_reason_no_require: { type: "string", description: "无数据打标理由是否必选 0 否 1 是" },
            is_pc: { type: "string", description: "" },
            is_need_rejects_vessel: { type: "string", description: "是否需要不良品容器{0 否 1 是}" },
            is_need_no_data_vessel: { type: "string", description: "是否需要无数据容器{0 否 1 是}" },
            container_lock_similar_pack: {
                type: "string",
                description: "PC点货一个容器只允许同类型包裹配置 :{0:关闭，1.开启}",
            },
            exchange_max_days: { type: "string", description: "全平台商品不退换日期设置" },
            no_return_goods_no: { type: "string", description: "售后指定商品不退换-货号" },
            no_return_tips: { type: "string", description: "售后指定商品不退换-提示文案" },
            no_return_tips_time: { type: "string", description: "提示时间" },
            "unreason_setting[0][identity]": { type: "string", description: "身份" },
            "unreason_setting[0][not_us_goods_num]": { type: "string", description: "非我司改标数量" },
            "unreason_setting[0][involving_supply_num]": { type: "string", description: "供应商数量" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "alertLockScreenSettingSave",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货\/拆包 设置↗](http://yapi.yishou.com/project/128/interface/api/29942) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `三方仓支持前置仓`, `爆版4.23.0`, `#2685指定货号不能退换货`, `#2904非我司改标`
 * @请求头 `POST /erp/Work/alertLockScreenSettingSave`
 */
export const alertLockScreenSettingSave = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(alertLockScreenSettingSaveRequestConfig, requestData), ...args);
};
alertLockScreenSettingSave.requestConfig = alertLockScreenSettingSaveRequestConfig;
/**
 * 接口 [PC点货-无数据打标↗](http://yapi.yishou.com/project/128/interface/api/29945) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/nodataTakeStock`
 */
const nodataTakeStockRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/takeStock/nodataTakeStock",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pgid", "supply_id", "dh_num", "reason"],
        properties: {
            pgid: { type: "string", description: "采购组" },
            supply_id: { type: "string", description: "供应商" },
            dh_num: { type: "string", description: "点货数量" },
            reason: { type: "string", description: "无数据理由" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            print_data: {
                type: "object",
                properties: {
                    cmd: { type: "string" },
                    requestID: { type: "number" },
                    version: { type: "string" },
                    task: {
                        type: "object",
                        properties: {
                            taskID: { type: "string" },
                            preview: { type: "boolean" },
                            previewType: { type: "string" },
                            firstDocumentNumber: { type: "number" },
                            totalDocumentCount: { type: "number" },
                            documents: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        documentID: { type: "string" },
                                        contents: {
                                            type: "array",
                                            items: {
                                                type: "object",
                                                properties: {
                                                    data: {
                                                        type: "object",
                                                        properties: {
                                                            goods_name: { type: "string" },
                                                            supply_name: { type: "string" },
                                                            package_no: { type: "string" },
                                                            create_time: { type: "string" },
                                                            pici: { type: "string" },
                                                            no_data_id: { type: "string" },
                                                            co_val: { type: "string" },
                                                            si_val: { type: "string" },
                                                            qr_code: { type: "string" },
                                                            sku: { type: "string", description: "无数据理由" },
                                                            pgname: { type: "string" },
                                                            da_biao_time: { type: "string" },
                                                        },
                                                    },
                                                    templateURL: { type: "string" },
                                                },
                                                required: ["data", "templateURL"],
                                            },
                                        },
                                    },
                                    required: ["documentID", "contents"],
                                },
                            },
                        },
                    },
                },
            },
            end_data: {
                type: "object",
                properties: {
                    cmd: { type: "string" },
                    requestID: { type: "number" },
                    version: { type: "string" },
                    task: {
                        type: "object",
                        properties: {
                            taskID: { type: "string" },
                            preview: { type: "boolean" },
                            previewType: { type: "string" },
                            firstDocumentNumber: { type: "number" },
                            totalDocumentCount: { type: "number" },
                            documents: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        documentID: { type: "string" },
                                        contents: {
                                            type: "array",
                                            items: {
                                                type: "object",
                                                properties: {
                                                    data: {
                                                        type: "object",
                                                        properties: {
                                                            line1: { type: "string" },
                                                            line2: { type: "string" },
                                                            line3: { type: "string" },
                                                            line4: { type: "string" },
                                                        },
                                                    },
                                                    templateURL: { type: "string" },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    requestFunctionName: "nodataTakeStock",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-无数据打标↗](http://yapi.yishou.com/project/128/interface/api/29945) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/nodataTakeStock`
 */
export const nodataTakeStock = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(nodataTakeStockRequestConfig, requestData), ...args);
};
nodataTakeStock.requestConfig = nodataTakeStockRequestConfig;
/**
 * 接口 [PC点货-无数据打标-展示↗](http://yapi.yishou.com/project/128/interface/api/29946) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/getNoDataTakeStockList`
 */
const getNoDataTakeStockListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/takeStock/getNoDataTakeStockList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        ndgid: { type: "string" },
                        no_data_reason: { type: "string", description: "key" },
                        reason: { type: "string", description: "无数据理由" },
                    },
                    required: ["ndgid", "no_data_reason", "reason"],
                },
            },
            reason: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        key: { type: "number", description: "key" },
                        label: { type: "string", description: "理由描述" },
                    },
                    required: ["key", "label"],
                },
                description: "无数据理由选项",
            },
            is_no_data_reason: { type: "number", description: "无数据理由选项是否必填 0 否 1 是" },
        },
    },
    requestFunctionName: "getNoDataTakeStockList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-无数据打标-展示↗](http://yapi.yishou.com/project/128/interface/api/29946) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/getNoDataTakeStockList`
 */
export const getNoDataTakeStockList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataTakeStockListRequestConfig, requestData), ...args);
};
getNoDataTakeStockList.requestConfig = getNoDataTakeStockListRequestConfig;
/**
 * 接口 [无数据打标-理由数据↗](http://yapi.yishou.com/project/128/interface/api/29947) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `GET /erp/NoDataGoods/getNoDataGoodsReason`
 */
const getNoDataGoodsReasonRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/getNoDataGoodsReason",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            reason: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "无数据理由选项",
            },
            is_no_data_reason: { type: "number", description: "无数据理由是否必选 0 否 1 是" },
        },
    },
    requestFunctionName: "getNoDataGoodsReason",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据打标-理由数据↗](http://yapi.yishou.com/project/128/interface/api/29947) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `GET /erp/NoDataGoods/getNoDataGoodsReason`
 */
export const getNoDataGoodsReason = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataGoodsReasonRequestConfig, requestData), ...args);
};
getNoDataGoodsReason.requestConfig = getNoDataGoodsReasonRequestConfig;
/**
 * 接口 [无数据点货-新建无数据商品↗](http://yapi.yishou.com/project/128/interface/api/29948) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/createNoDataGoodsId`
 */
const createNoDataGoodsIdRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/createNoDataGoodsId",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "num", "reason", "is_pc"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            num: { type: "string", description: "数量" },
            reason: { type: "string", description: "理由key" },
            is_pc: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            ndgids: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        ndgid: { type: "string" },
                        no_data_reason: { type: "string", description: "理由key" },
                        reason: { type: "string", description: "理由描述" },
                    },
                    required: ["ndgid", "no_data_reason", "reason"],
                },
            },
            print_data: {
                type: "object",
                properties: {
                    cmd: { type: "string" },
                    requestID: { type: "number" },
                    version: { type: "string" },
                    task: {
                        type: "object",
                        properties: {
                            taskID: { type: "string" },
                            preview: { type: "boolean" },
                            previewType: { type: "string" },
                            firstDocumentNumber: { type: "number" },
                            totalDocumentCount: { type: "number" },
                            documents: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        documentID: { type: "string" },
                                        contents: {
                                            type: "array",
                                            items: {
                                                type: "object",
                                                properties: {
                                                    data: {
                                                        type: "object",
                                                        properties: {
                                                            goods_name: { type: "string" },
                                                            supply_name: { type: "string" },
                                                            package_no: { type: "string" },
                                                            create_time: { type: "string" },
                                                            pici: { type: "string" },
                                                            no_data_id: { type: "string" },
                                                            co_val: { type: "string" },
                                                            si_val: { type: "string" },
                                                            qr_code: { type: "string" },
                                                            sku: { type: "string", description: "无数据打标理由" },
                                                            pgname: { type: "string" },
                                                            da_biao_time: { type: "string" },
                                                        },
                                                    },
                                                    templateURL: { type: "string" },
                                                },
                                                required: ["data", "templateURL"],
                                            },
                                        },
                                    },
                                    required: ["documentID", "contents"],
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    requestFunctionName: "createNoDataGoodsId",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据点货-新建无数据商品↗](http://yapi.yishou.com/project/128/interface/api/29948) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/createNoDataGoodsId`
 */
export const createNoDataGoodsId = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createNoDataGoodsIdRequestConfig, requestData), ...args);
};
createNoDataGoodsId.requestConfig = createNoDataGoodsIdRequestConfig;
/**
 * 接口 [无数据商品列表↗](http://yapi.yishou.com/project/128/interface/api/29950) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#4061`
 * @请求头 `POST /erp/NoDataGoods/noDataGoodsList`
 */
const noDataGoodsListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/noDataGoodsList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["time[]", "is_pc", "is_verify", "no_data_package_no", "return_mode"],
        properties: {
            "time[]": { type: "string", description: "时间数组【开始，结束】" },
            is_pc: { type: "string", description: "" },
            select_type: { type: "string", description: "查询字段" },
            select_type_value: { type: "string", description: "查询内容" },
            pgid: { type: "string", description: "" },
            pg_member_id: { type: "string", description: "" },
            blp_type: { type: "string", description: "" },
            handle_state: {
                type: "string",
                description: "1:待处理:,2:采购待处理,3:放行退还,4:已点货,5:其他入库,7:已作废,8:确认归还 9 待放行退还",
            },
            is_stop: { type: "string", description: "" },
            dh_type: { type: "string", description: "" },
            curPage: { type: "string", description: "" },
            package_type: { type: "string", description: "" },
            page_size: { type: "string", description: "" },
            page: { type: "string", description: "" },
            is_excel: { type: "string", description: "是否导出Excel" },
            is_verify: { type: "string", description: "是否核实 0 全部  1 是 2 否" },
            no_data_package_no: { type: "string", description: "无数据包裹号" },
            return_mode: { type: "string", description: "退回方式" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        ndgid: { type: "string" },
                        pici_no: { type: "string" },
                        package_no: { type: "string" },
                        supply_name: { type: "string" },
                        supply_id: { type: "string" },
                        img: { type: "string" },
                        co_val: { type: "string" },
                        si_val: { type: "string" },
                        co_id: { type: "string" },
                        si_id: { type: "string" },
                        dbid: { type: "string" },
                        pgname: { type: "string" },
                        storehouse_id: { type: "string" },
                        admin_name: { type: "string" },
                        handle_admin_name: { type: "string" },
                        create_time: { type: "string" },
                        note: { type: "string" },
                        position: { type: "string" },
                        handle_state: { type: "string" },
                        invalid_note: { type: "string" },
                        handle_state_text: { type: "string" },
                        goods_name: { type: "string" },
                        goods_no: { type: "string" },
                        goods_kh: { type: "string" },
                        blp_type: { type: "string" },
                        pg_member_name: { type: "string" },
                        blpid: { type: "null" },
                        is_stop: { type: "string" },
                        handle_time: { type: "string" },
                        blp_note: { type: "null" },
                        no_data_reason: { type: "string" },
                        is_verify: { type: "string" },
                        verify_sku: { type: "string" },
                        verify_text: { type: "string" },
                        image_turn_over: { type: "string" },
                        origin: { type: "string" },
                        dh_type: { type: "string" },
                        is_stop_text: { type: "string" },
                        package_type: { type: "string" },
                        no_data_goods_origin: { type: "string" },
                        no_data_reason_text: { type: "string" },
                        is_verify_text: { type: "string" },
                        image_turn_over_arr: { type: "array", items: { type: "string" } },
                        signing_time: { type: "string" },
                        signing_name: { type: "string" },
                        no_data_package_no: { type: "string" },
                        package_img_arr: { type: "object", properties: {}, description: "包裹图片数组" },
                        package_img: { type: "string", description: "包裹图片" },
                        buyer_datetime: { type: "string", description: "移交代采时间" },
                        return_datetime: { type: "string", description: "提交退还时间" },
                        pack_datetime: { type: "string", description: "退还打包时间" },
                        return_mode_str: { type: "string", description: "退回方式", tag: "#4061" },
                        return_express_info: { type: "string", description: "快递寄回收件信息", tag: "#4061" },
                    },
                    required: [
                        "package_img",
                        "package_img_arr",
                        "pack_datetime",
                        "return_datetime",
                        "buyer_datetime",
                        "return_express_info",
                        "return_mode_str",
                    ],
                },
            },
            count: { type: "number" },
        },
    },
    requestFunctionName: "noDataGoodsList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据商品列表↗](http://yapi.yishou.com/project/128/interface/api/29950) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#4061`
 * @请求头 `POST /erp/NoDataGoods/noDataGoodsList`
 */
export const noDataGoodsList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(noDataGoodsListRequestConfig, requestData), ...args);
};
noDataGoodsList.requestConfig = noDataGoodsListRequestConfig;
/**
 * 接口 [保存质检改标配置↗](http://yapi.yishou.com/project/128/interface/api/30422) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `高级质检`
 * @请求头 `POST /erp/AdminSetting/qualityLabelSetting`
 */
const qualityLabelSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/qualityLabelSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "max_quality_task_goods_num",
            "max_quality_yes_remark_wave_summary_num",
            "max_quality_no_remark_wave_summary_num",
            "max_label_task_goods_num",
            "max_label_task_wave_limit_num",
            "max_label_group_num",
            "quality_text",
            "quality_text_time",
            "open_quality_wave",
            "is_only_summary_picking",
            "vip_hg_quality",
            "is_height_goods_safety_clasp",
        ],
        properties: {
            max_quality_task_goods_num: { type: "string", description: "质检任务最大商品数" },
            max_quality_yes_remark_wave_summary_num: { type: "string", description: "质检有备注汇总波次最大数" },
            max_quality_no_remark_wave_summary_num: { type: "string", description: "质检无备注汇总波次最大数" },
            max_label_task_goods_num: { type: "string", description: "一次点击生成拣货任务最大商品数" },
            max_label_task_wave_limit_num: { type: "string", description: "拣货任务波次上限数" },
            max_label_group_num: { type: "string", description: "改标用户分组设置上限" },
            quality_text: { type: "string", description: "PC质检提示" },
            quality_text_time: { type: "string", description: "PC质检提示时间" },
            open_quality_wave: { type: "string", description: "是否开启质检波次" },
            is_only_summary_picking: { type: "string", description: "是否单汇总生成拣货任务" },
            vip_hg_quality: { type: "string", description: "质检vip中分分组配置" },
            is_height_goods_safety_clasp: { type: "string", description: "是否开启高货值商品扣安全扣提醒{1:开启，2:不开启}" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "qualityLabelSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [保存质检改标配置↗](http://yapi.yishou.com/project/128/interface/api/30422) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `高级质检`
 * @请求头 `POST /erp/AdminSetting/qualityLabelSetting`
 */
export const qualityLabelSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(qualityLabelSettingRequestConfig, requestData), ...args);
};
qualityLabelSetting.requestConfig = qualityLabelSettingRequestConfig;
/**
 * 接口 [PC点货-获取欠货↗](http://yapi.yishou.com/project/128/interface/api/30490) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/TakeStock/getTakeStockGoodsList`
 */
const getTakeStockGoodsListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/TakeStock/getTakeStockGoodsList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "pgid", "owe_type"],
        properties: {
            supply_id: { type: "string" },
            pgid: { type: "string", description: "" },
            owe_type: { type: "string", description: "1 商家欠货 2 商家配货欠货" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        goods_no: { type: "string" },
                        goods_kh: { type: "string" },
                        owe_num: { type: "number" },
                        goods_img: { type: "string" },
                        delivery_num: { type: "string", description: "今日配货欠货数量" },
                        owe_delivery_num: { type: "string", description: "今日配货欠货数量（去掉当前已打标数量）" },
                        ydh_num: { type: "string", description: "已打标数量" },
                    },
                    required: ["goods_no", "goods_kh", "owe_num", "goods_img", "ydh_num", "owe_delivery_num", "delivery_num"],
                },
            },
            has_order: { type: "number" },
            supply_tip: { type: "string" },
            rejects_vessel: { type: "number", description: "是否需要不良品容器 {0 否 1 是}" },
            no_data_vessel: { type: "number", description: "是否需要无数据容器 {0 否 1 是}" },
            is_qz_bool: { type: "string", description: "是否前置仓包裹 0 否 1 是" },
            total_owe_num: { type: "string", description: "按商家欠货点货数量" },
            total_owe_delivery_num: { type: "string", description: "按商家配货点货数量" },
            today_package_num: { type: "string", description: "商家今日送货包裹数量" },
            today_tally_package_num: { type: "string", description: "商家点货包裹数量" },
            today_delivery_num: { type: "string", description: "商家今日配货件数" },
            today_db_num: { type: "string", description: "商家今日打标件数" },
        },
        required: [
            "is_qz_bool",
            "today_db_num",
            "today_delivery_num",
            "today_tally_package_num",
            "today_package_num",
            "total_owe_delivery_num",
            "total_owe_num",
        ],
    },
    requestFunctionName: "getTakeStockGoodsList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-获取欠货↗](http://yapi.yishou.com/project/128/interface/api/30490) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/TakeStock/getTakeStockGoodsList`
 */
export const getTakeStockGoodsList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getTakeStockGoodsListRequestConfig, requestData), ...args);
};
getTakeStockGoodsList.requestConfig = getTakeStockGoodsListRequestConfig;
/**
 * 接口 [脚本配置↗](http://yapi.yishou.com/project/128/interface/api/30582) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getTodayAllotSetting`
 */
const getTodayAllotSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/getTodayAllotSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            setting: {
                type: "object",
                properties: {
                    is_open: { type: "string" },
                    mark_surpass: { type: "string" },
                    space_area: { type: "array", items: { type: "string" } },
                },
            },
            area_setting: {
                type: "object",
                properties: { space_area: { type: "array", items: { type: "string" }, description: "配货仓区" } },
                description: "配货仓区配置项",
            },
            space_areas: { type: "array", items: { type: "string" } },
        },
    },
    requestFunctionName: "getTodayAllotSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [脚本配置↗](http://yapi.yishou.com/project/128/interface/api/30582) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getTodayAllotSetting`
 */
export const getTodayAllotSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getTodayAllotSettingRequestConfig, requestData), ...args);
};
getTodayAllotSetting.requestConfig = getTodayAllotSettingRequestConfig;
/**
 * 接口 [配货仓区配置项↗](http://yapi.yishou.com/project/128/interface/api/30586) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/saveDistributionArea`
 */
const saveDistributionAreaRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/saveDistributionArea",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["space_area[]"],
        properties: { "space_area[]": { type: "string", description: "配货仓区 数组" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "saveDistributionArea",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [配货仓区配置项↗](http://yapi.yishou.com/project/128/interface/api/30586) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/saveDistributionArea`
 */
export const saveDistributionArea = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveDistributionAreaRequestConfig, requestData), ...args);
};
saveDistributionArea.requestConfig = saveDistributionAreaRequestConfig;
/**
 * 接口 [波次校验配置↗](http://yapi.yishou.com/project/128/interface/api/30734) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/WavePicking/CheckSetting`
 */
const checkSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/CheckSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "check_one",
            "label_must_hecha",
            "check_one_num_valid",
            "picking_and_hecha",
            "wp_split_auto_pack_remaining",
            "quality_inspection_must_checked",
            "origin",
            "origin_txt",
        ],
        properties: {
            check_one: { type: "string", description: "是否开启设备分播无异常波次一键打包" },
            label_must_hecha: { type: "string", description: "改标波次必须通过波次核查才能校验" },
            check_one_num_valid: { type: "string", description: "一件打包是否校验数量" },
            picking_and_hecha: { type: "string", description: "必须通过拣货或核查才能校验" },
            wp_split_auto_pack_remaining: { type: "string", description: "拆分发货剩余商品是否允许自动完成打包" },
            quality_inspection_must_checked: { type: "string", description: "质检波次必须通过波次核查才能校验 （新增字段）" },
            origin: { type: "string", description: "仓库ID" },
            origin_txt: { type: "string", description: "仓库名称" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "checkSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [波次校验配置↗](http://yapi.yishou.com/project/128/interface/api/30734) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/WavePicking/CheckSetting`
 */
export const checkSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(checkSettingRequestConfig, requestData), ...args);
};
checkSetting.requestConfig = checkSettingRequestConfig;
/**
 * 接口 [保存质检规则配置↗](http://yapi.yishou.com/project/128/interface/api/31798) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `多维度质检规则`
 * @请求头 `POST /erp/AdminSetting/qualityRuleSettingSave`
 */
const qualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/qualityRuleSettingSave",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            rule_type: { type: "integer", description: "1" },
            rule_data: {
                type: "object",
                properties: {
                    open: { type: "integer", description: "1" },
                    checked: { type: "array", items: { type: "integer", description: "1" }, description: "[1,2,3]" },
                    level: { type: "integer", description: "1" },
                    hg_id: { type: "array", items: { type: "integer", description: "1" }, description: "[1,2,3]" },
                    days: { type: "integer", description: "7" },
                    price: { type: "string", description: '"300"' },
                    pd_days: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                destination_province: { type: "string", description: '"广东省"' },
                                quality_testing_after_day: { type: "integer", description: "3" },
                            },
                            additionalProperties: false,
                        },
                        description: '[{"destination_province":"广东省","quality_testing_after_day":3}]',
                    },
                },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "qualityRuleSettingSave",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [保存质检规则配置↗](http://yapi.yishou.com/project/128/interface/api/31798) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `多维度质检规则`
 * @请求头 `POST /erp/AdminSetting/qualityRuleSettingSave`
 */
export const qualityRuleSettingSave = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(qualityRuleSettingSaveRequestConfig, requestData), ...args);
};
qualityRuleSettingSave.requestConfig = qualityRuleSettingSaveRequestConfig;
/**
 * 接口 [获取质检规则配置↗](http://yapi.yishou.com/project/128/interface/api/31802) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `多维度质检规则`
 * @请求头 `GET /AdminSetting/qualityRuleSettingGet`
 */
const qualityRuleSettingGetRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/AdminSetting/qualityRuleSettingGet",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            type_1_options: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "integer", description: "1" },
                        label: { type: "string", description: '"首单金额150以上"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"value":1,"label":"首单金额150以上"},{"value":2,"label":"累计下单15件一下且次品率大于大于等于10%"},{"value":3,"label":"累计下单15件以上且次品率大于等于12%"},{"value":4,"label":"地推首5单"},{"value":7,"label":"非地推首5单"},{"value":5,"label":"前3天有两个质量问题类型工单"}]',
            },
            lavel: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "integer", description: "1" },
                        label: { type: "string", description: '"初级质检"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"value":1,"label":"初级质检"},{"value":2,"label":"高级质检"},{"value":3,"label":"精心质检"}]',
            },
            halve_group: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        label: { type: "string", description: '"wmx测试"' },
                        value: { type: "integer", description: "246" },
                    },
                    additionalProperties: false,
                },
                description: '[{"label":"wmx测试","value":246},{"label":"鹿丸","value":222},{"label":"高检vi2","value":220},{"label":"普检vip","value":219},{"label":"高检VIP","value":217},{"label":"明熹中分","value":79},{"label":"WZ","value":70},{"label":"广州质检01","value":61},{"label":"质检中分位1","value":60},{"label":"继明中分位分组03","value":56},{"label":"质检","value":42}]',
            },
            rule_data: {
                type: "object",
                properties: {
                    "1": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "1" },
                            hg_id: { type: "array", items: { type: "integer", description: "42" }, description: "[42]" },
                            checked: { type: "array", items: { type: "integer", description: "1" }, description: "[1,4,7,2,3,5]" },
                        },
                        additionalProperties: false,
                    },
                    "2": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "1" },
                            hg_id: { type: "array", items: { type: "integer", description: "70" }, description: "[70]" },
                        },
                        additionalProperties: false,
                    },
                    "3": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "2" },
                            hg_id: { type: "array", items: { type: "integer", description: "220" }, description: "[220,219,217]" },
                        },
                        additionalProperties: false,
                    },
                    "4": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "2" },
                            hg_id: { type: "array", items: { type: "integer", description: "56" }, description: "[56]" },
                            days: { type: "integer", description: "5" },
                        },
                        additionalProperties: false,
                    },
                    "5": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "2" },
                            hg_id: { type: "array", items: { type: "integer", description: "79" }, description: "[79]" },
                            price: { type: "integer", description: "400" },
                        },
                        additionalProperties: false,
                    },
                    "6": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "3" },
                            hg_id: { type: "array", items: { type: "integer", description: "222" }, description: "[222]" },
                            pd_days: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        destination_province: { type: "string", description: '"贵州省"' },
                                        average_day: { type: "integer", description: "3" },
                                        quality_testing_after_day: { type: "integer", description: "1" },
                                    },
                                    additionalProperties: false,
                                },
                                description: '[{"destination_province":"贵州省","average_day":3,"quality_testing_after_day":1},{"destination_province":"湖南省","average_day":3,"quality_testing_after_day":1},{"destination_province":"西藏自治区","average_day":5,"quality_testing_after_day":1},{"destination_province":"重庆","average_day":3,"quality_testing_after_day":1},{"destination_province":"江苏省","average_day":3,"quality_testing_after_day":1},{"destination_province":"香港","average_day":2,"quality_testing_after_day":1},{"destination_province":"山西省","average_day":4,"quality_testing_after_day":1},{"destination_province":"安徽省","average_day":3,"quality_testing_after_day":1},{"destination_province":"青海省","average_day":4,"quality_testing_after_day":1},{"destination_province":"澳门","average_day":8,"quality_testing_after_day":1},{"destination_province":"陕西省","average_day":3,"quality_testing_after_day":1},{"destination_province":"新疆维吾尔自治区","average_day":6,"quality_testing_after_day":1},{"destination_province":"福建省","average_day":3,"quality_testing_after_day":1},{"destination_province":"云南省","average_day":3,"quality_testing_after_day":1},{"destination_province":"甘肃省","average_day":4,"quality_testing_after_day":1},{"destination_province":"辽宁省","average_day":5,"quality_testing_after_day":1},{"destination_province":"上海","average_day":3,"quality_testing_after_day":1},{"destination_province":"内蒙古自治区","average_day":5,"quality_testing_after_day":1},{"destination_province":"河南省","average_day":3,"quality_testing_after_day":1},{"destination_province":"江西省","average_day":3,"quality_testing_after_day":1},{"destination_province":"广东省","average_day":2,"quality_testing_after_day":1},{"destination_province":"黑龙江省","average_day":5,"quality_testing_after_day":1},{"destination_province":"海南省","average_day":3,"quality_testing_after_day":1},{"destination_province":"广西壮族自治区","average_day":3,"quality_testing_after_day":1},{"destination_province":"台湾","average_day":4,"quality_testing_after_day":2},{"destination_province":"河北省","average_day":4,"quality_testing_after_day":1},{"destination_province":"湖北省","average_day":3,"quality_testing_after_day":1},{"destination_province":"北京","average_day":4,"quality_testing_after_day":1},{"destination_province":"四川省","average_day":3,"quality_testing_after_day":1},{"destination_province":"浙江省","average_day":3,"quality_testing_after_day":1},{"destination_province":"天津","average_day":4,"quality_testing_after_day":1},{"destination_province":"吉林省","average_day":5,"quality_testing_after_day":1},{"destination_province":"宁夏回族自治区","average_day":4,"quality_testing_after_day":1},{"destination_province":"山东省","average_day":3,"quality_testing_after_day":1}]',
                            },
                        },
                        additionalProperties: false,
                    },
                    "7": {
                        type: "object",
                        properties: {
                            open: { type: "integer", description: "1" },
                            level: { type: "integer", description: "2" },
                            hg_id: { type: "array", items: { type: "integer", description: "79" }, description: "[79,217,219,220]" },
                            channel_data: {
                                type: "object",
                                properties: {
                                    "1": {
                                        type: "object",
                                        properties: {
                                            channel_id: { type: "string", description: '"1"' },
                                            channel_name: { type: "string", description: '"其他"' },
                                            channel_open: { type: "string", description: '"0"' },
                                            identity_type: { type: "array", description: "[]" },
                                            user_tail_number: {
                                                type: "array",
                                                items: { type: "integer", description: "1" },
                                                description: "[1,2,3,4,5,6,7,8]",
                                            },
                                            user_level_start: { type: "string" },
                                            user_level_end: { type: "string" },
                                            order_amount: { type: "string", description: '"1"' },
                                        },
                                        additionalProperties: false,
                                    },
                                    "30": {
                                        type: "object",
                                        properties: {
                                            channel_id: { type: "string", description: '"30"' },
                                            channel_name: { type: "string", description: '"用户裂变"' },
                                            channel_open: { type: "string", description: '"0"' },
                                            identity_type: { type: "array", description: "[]" },
                                            user_tail_number: {
                                                type: "array",
                                                items: { type: "integer", description: "1" },
                                                description: "[1,2,3,4,5,6,7,8]",
                                            },
                                            user_level_start: { type: "string" },
                                            user_level_end: { type: "string" },
                                            order_amount: { type: "string", description: '"10"' },
                                        },
                                        additionalProperties: false,
                                    },
                                    "145": {
                                        type: "object",
                                        properties: {
                                            channel_id: { type: "string", description: '"145"' },
                                            channel_name: { type: "string", description: '"搜索引擎"' },
                                            channel_open: { type: "string", description: '"0"' },
                                            identity_type: { type: "array", description: "[]" },
                                            user_tail_number: {
                                                type: "array",
                                                items: { type: "integer", description: "1" },
                                                description: "[1,2,3,4,5,6,7,8]",
                                            },
                                            user_level_start: { type: "string" },
                                            user_level_end: { type: "string" },
                                            order_amount: { type: "string", description: '"10"' },
                                        },
                                        additionalProperties: false,
                                    },
                                    "1634": {
                                        type: "object",
                                        properties: {
                                            channel_id: { type: "string", description: '"1634"' },
                                            channel_name: { type: "string", description: '"地推"' },
                                            channel_open: { type: "string", description: '"0"' },
                                            identity_type: { type: "array", description: "[]" },
                                            user_tail_number: {
                                                type: "array",
                                                items: { type: "integer", description: "1" },
                                                description: "[1,2,3,4,5,6,7,8]",
                                            },
                                            user_level_start: { type: "string" },
                                            user_level_end: { type: "string" },
                                            order_amount: { type: "string", description: '"10"' },
                                        },
                                        additionalProperties: false,
                                    },
                                    "1640": {
                                        type: "object",
                                        properties: {
                                            channel_id: { type: "string", description: '"1640"' },
                                            channel_name: { type: "string", description: '"应用市场"' },
                                            channel_open: { type: "string", description: '"1"' },
                                            identity_type: {
                                                type: "array",
                                                items: { type: "string", description: '"个人自用"' },
                                                description: '["个人自用","网商/地摊","准备开店"]',
                                            },
                                            user_tail_number: {
                                                type: "array",
                                                items: { type: "integer", description: "1" },
                                                description: "[1,2,3,4,5,6,7,8]",
                                            },
                                            user_level_start: { type: "string" },
                                            user_level_end: { type: "string" },
                                            order_amount: { type: "string", description: '"10"' },
                                        },
                                        additionalProperties: false,
                                    },
                                    "1739": {
                                        type: "object",
                                        properties: {
                                            channel_id: { type: "string", description: '"1739"' },
                                            channel_name: { type: "string", description: '"feeds流"' },
                                            channel_open: { type: "string", description: '"0"' },
                                            identity_type: { type: "array", description: "[]" },
                                            user_tail_number: { type: "array", description: "[]" },
                                            user_level_start: { type: "string" },
                                            user_level_end: { type: "string" },
                                            order_amount: { type: "string", description: '"10"' },
                                        },
                                        additionalProperties: false,
                                    },
                                },
                                additionalProperties: false,
                            },
                        },
                        additionalProperties: false,
                    },
                    "8": {
                        type: "object",
                        properties: {
                            open: { type: "integer" },
                            level: { type: "integer" },
                            hg_id: { type: "array", description: "[]" },
                            user_tail_number: { type: "array", description: "[]" },
                            user_net_worth: { type: "array", description: "[]" },
                        },
                        additionalProperties: false,
                    },
                },
                additionalProperties: false,
            },
            high_value_user_tag: {
                type: "array",
                items: { type: "string", description: '"A1"' },
                description: '["A1","A2","A3","A4","A5","A6","A7","A8","A9","A10","A11","A12","A13","A14","A15","A16","A17","A18","A19","A20","A21","A22","A23","A24","A25","A26","A27","A28","A29","A30","A31","A32","A33","A34","A35","A36","A37","A38","A39","A40","A41","A42","A43","A44","A45","A46","A47","A48","A49","A50","A51","A52","A53","A54","A55","A56","A57","A58","A59","A60","A61","A62","A63","A64","A65","A66","A67","A68","A69","A70","A71","A72","A73","A74","A75","A76","A77","A78","A79","A80","A81","A82","A83","A84","A85","A86","A87","A88","A89","A90","A91","A92","A93","A94","A95","A96","A97","A98","A99","A100","A101","A102","A103","A104","A105","A106"]',
            },
            user_identity_tag: {
                type: "array",
                items: { type: "string", description: '"实体店店主/工作室"' },
                description: '["实体店店主/工作室","微商/代理","网商/地摊","批发商/厂家","个人自用","其他","主播","准备开店","未填写"]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "qualityRuleSettingGet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取质检规则配置↗](http://yapi.yishou.com/project/128/interface/api/31802) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `多维度质检规则`
 * @请求头 `GET /AdminSetting/qualityRuleSettingGet`
 */
export const qualityRuleSettingGet = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(qualityRuleSettingGetRequestConfig, requestData), ...args);
};
qualityRuleSettingGet.requestConfig = qualityRuleSettingGetRequestConfig;
/**
 * 接口 [推送配置获取↗](http://yapi.yishou.com/project/128/interface/api/33027) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `三方仓支持前置仓`
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingGet`
 */
const pushTaskSettingGetRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/pushTaskSettingGet",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            rule_data: {
                type: "object",
                properties: {
                    push_upshelf_setting: {
                        type: "object",
                        properties: { package_type: { type: "array", items: { type: "string" }, description: "包裹类型" } },
                        description: "上架设置",
                    },
                    push_picking_setting: {
                        type: "object",
                        properties: { shipping_space: { type: "array", items: { type: "string" }, description: "仓区" } },
                        description: "拣货设置",
                    },
                    push_return_setting: {
                        type: "object",
                        properties: { open_return_task_push: { type: "number", description: "退供任务推送{0:关闭，1:开启}" } },
                        description: "退供任务",
                    },
                },
            },
            package_type_options: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "number" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
                description: "包裹选择项",
            },
            shipping_space_options: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
                description: "仓区选择项",
            },
        },
    },
    requestFunctionName: "pushTaskSettingGet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [推送配置获取↗](http://yapi.yishou.com/project/128/interface/api/33027) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `三方仓支持前置仓`
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingGet`
 */
export const pushTaskSettingGet = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(pushTaskSettingGetRequestConfig, requestData), ...args);
};
pushTaskSettingGet.requestConfig = pushTaskSettingGetRequestConfig;
/**
 * 接口 [推送配置修改↗](http://yapi.yishou.com/project/128/interface/api/33031) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingSave`
 */
const pushTaskSettingSaveRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/pushTaskSettingSave",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["type", "package_type[0]", "shipping_space[0]", "open_return_task_push"],
        properties: {
            type: { type: "string", description: "{1:上架任务设置，2：拣货任务设置，3：退供任务设置}" },
            "package_type[0]": { type: "string", description: "包裹类型数组，传1才修改这个" },
            "shipping_space[0]": { type: "string", description: "仓区类型数组，传2才修改" },
            open_return_task_push: { type: "string", description: "开启退供任务推送{0：关闭，1：开启}，传3才修改" },
        },
    },
    responseDataJsonSchema: {},
    requestFunctionName: "pushTaskSettingSave",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [推送配置修改↗](http://yapi.yishou.com/project/128/interface/api/33031) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingSave`
 */
export const pushTaskSettingSave = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(pushTaskSettingSaveRequestConfig, requestData), ...args);
};
pushTaskSettingSave.requestConfig = pushTaskSettingSaveRequestConfig;
/**
 * 接口 [PC点货拆包配置获取↗](http://yapi.yishou.com/project/128/interface/api/33040) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#2685指定货号不能退换货`
 * @请求头 `POST /erp/Work/alertLockScreenSettingGet`
 */
const alertLockScreenSettingGetRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/alertLockScreenSettingGet",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_setting_page"],
        properties: { is_setting_page: { type: "string", description: "是否配置页面{1:是,2:否}" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            data: {
                type: "object",
                properties: {
                    no_return_goods_no: {
                        type: "array",
                        items: { type: "string", description: '"123"' },
                        description: '["123","345"]',
                    },
                    no_return_tips: { type: "string", description: '"提示文案呢???"' },
                    no_return_tips_time: { type: "integer", description: "3" },
                    db_btn_diabled_num: { type: "integer" },
                    db_tips_text: { type: "string" },
                    db_tips_time: { type: "integer" },
                    unpack_text: { type: "string", description: '"售后拆包看到提示可以无视666"' },
                    unpack_time: { type: "string", description: '"0"' },
                    db_package_no_require: { type: "integer" },
                    pda_receive_package_no_require: { type: "integer" },
                    take_stock_tip_supply: {
                        type: "array",
                        items: { type: "string", description: '"72623"' },
                        description: '["72623","72809"]',
                    },
                    take_stock_tip_msg: { type: "string", description: '"质检商品请移交质检55555"' },
                    old_goods_return_max_day: { type: "string" },
                    no_data_reason_no_require: { type: "integer", description: "1" },
                    is_need_rejects_vessel: { type: "integer", description: "1" },
                    is_need_no_data_vessel: { type: "integer", description: "1" },
                    container_lock_similar_pack: { type: "integer", description: "1" },
                    exchange_max_days: { type: "string", description: '"2"' },
                },
                additionalProperties: false,
            },
            supply_option: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        supply_id: { type: "string", description: '"72623"' },
                        supply_name: { type: "string", description: '"6-666-岳阳楼记新的呢"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"supply_id":"72623","supply_name":"6-666-岳阳楼记新的呢"},{"supply_id":"72809","supply_name":"负2-A-C12311-爆款"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "alertLockScreenSettingGet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货拆包配置获取↗](http://yapi.yishou.com/project/128/interface/api/33040) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#2685指定货号不能退换货`
 * @请求头 `POST /erp/Work/alertLockScreenSettingGet`
 */
export const alertLockScreenSettingGet = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(alertLockScreenSettingGetRequestConfig, requestData), ...args);
};
alertLockScreenSettingGet.requestConfig = alertLockScreenSettingGetRequestConfig;
/**
 * 接口 [新PC点货-无数据撤标↗](http://yapi.yishou.com/project/128/interface/api/33279) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/removeNoDtaTakeStock`
 */
const removeNoDtaTakeStockRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/takeStock/removeNoDtaTakeStock",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["type", "ndgid"],
        properties: {
            type: { type: "string", description: "删除方式 0 单个， 1 全部" },
            ndgid: { type: "string", description: "无数据打标ID（当删除方式为单个的时候生效且为必须）" },
        },
    },
    responseDataJsonSchema: {},
    requestFunctionName: "removeNoDtaTakeStock",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新PC点货-无数据撤标↗](http://yapi.yishou.com/project/128/interface/api/33279) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/removeNoDtaTakeStock`
 */
export const removeNoDtaTakeStock = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(removeNoDtaTakeStockRequestConfig, requestData), ...args);
};
removeNoDtaTakeStock.requestConfig = removeNoDtaTakeStockRequestConfig;
/**
 * 接口 [新PC点货-关闭容器↗](http://yapi.yishou.com/project/128/interface/api/33280) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/closeBox`
 */
const closeBoxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/takeStock/closeBox",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "closeBox",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新PC点货-关闭容器↗](http://yapi.yishou.com/project/128/interface/api/33280) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/takeStock/closeBox`
 */
export const closeBox = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(closeBoxRequestConfig, requestData), ...args);
};
closeBox.requestConfig = closeBoxRequestConfig;
/**
 * 接口 [无数据商品列表-移交采购↗](http://yapi.yishou.com/project/128/interface/api/33281) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/moveToPurchase`
 */
const moveToPurchaseRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/moveToPurchase",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["ndgids_data"],
        properties: { ndgids_data: { type: "string", description: "无数据移交采购json数组" } },
    },
    responseDataJsonSchema: {},
    requestFunctionName: "moveToPurchase",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据商品列表-移交采购↗](http://yapi.yishou.com/project/128/interface/api/33281) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/moveToPurchase`
 */
export const moveToPurchase = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(moveToPurchaseRequestConfig, requestData), ...args);
};
moveToPurchase.requestConfig = moveToPurchaseRequestConfig;
/**
 * 接口 [PC点货-获取单个商品点货信息↗](http://yapi.yishou.com/project/128/interface/api/33302) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/TakeStock/getTakeStockGoodsInfo`
 */
const getTakeStockGoodsInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/TakeStock/getTakeStockGoodsInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "pgid", "goods_no"],
        properties: {
            supply_id: { type: "string" },
            pgid: { type: "string", description: "" },
            goods_no: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            activity_goods: { type: "string" },
            supply_name: { type: "string" },
            brand_name: { type: "string" },
            goods_kh: { type: "string" },
            pg_member: { type: "string" },
            pgname: { type: "string" },
            goods_no: { type: "string" },
            parts: { type: "string" },
            cat_name: { type: "string" },
            cat: { type: "string" },
            goods_name: { type: "string" },
            goods_img: { type: "string" },
            imgs: { type: "array", items: { type: "string" } },
            colorCard: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        co_id: { type: "string" },
                        co_val: { type: "string" },
                        img: { type: "string" },
                        card_thumb: { type: "string" },
                        item: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    si_val: { type: "string" },
                                    si_id: { type: "string" },
                                    stock: { type: "string" },
                                    sku: { type: "string" },
                                },
                            },
                        },
                    },
                },
            },
            owe_num: { type: "number" },
            is_suit_or_parts: { type: "number" },
            detail: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        sku: { type: "string" },
                        pgid: { type: "string" },
                        supply_id: { type: "string" },
                        goods_no: { type: "string" },
                        si_id: { type: "string" },
                        co_id: { type: "string" },
                        si_val: { type: "string" },
                        co_val: { type: "string" },
                        sort: { type: "number" },
                        img: { type: "string" },
                        owe_num: { type: "string" },
                        ydh_num: { type: "number" },
                        ddh_num: { type: "string" },
                    },
                },
            },
            prop: { type: "array", items: { type: "string" } },
            is_qz_bool: { type: "number", description: "是否前置包裹 0 否 1 是" },
        },
    },
    requestFunctionName: "getTakeStockGoodsInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-获取单个商品点货信息↗](http://yapi.yishou.com/project/128/interface/api/33302) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/TakeStock/getTakeStockGoodsInfo`
 */
export const getTakeStockGoodsInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getTakeStockGoodsInfoRequestConfig, requestData), ...args);
};
getTakeStockGoodsInfo.requestConfig = getTakeStockGoodsInfoRequestConfig;
/**
 * 接口 [新客订单质检配置↗](http://yapi.yishou.com/project/128/interface/api/33589) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/newUserQualityRuleSettingSave`
 */
const newUserQualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/newUserQualityRuleSettingSave",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            rule_data: {
                type: "object",
                properties: {
                    open: { type: "integer", description: "1" },
                    level: { type: "integer", description: "2" },
                    hg_id: { type: "array", items: { type: "integer", description: "1" }, description: "[1,2,3]" },
                    channel_data: {
                        type: "object",
                        properties: {
                            "1": {
                                type: "object",
                                properties: {
                                    channel_id: { type: "integer", description: "1" },
                                    channel_name: { type: "string", description: '"其他"' },
                                    user_level_start: { type: "integer", description: "1" },
                                    user_level_end: { type: "integer", description: "7" },
                                    order_amount: { type: "integer", description: "1" },
                                    user_tail_number: {
                                        type: "array",
                                        items: { type: "integer", description: "1" },
                                        description: "[1,2,3,4]",
                                    },
                                    identity_type: {
                                        type: "array",
                                        items: { type: "string", description: '"个人自用"' },
                                        description: '["个人自用","网商/地摊","准备开店"]',
                                    },
                                    channel_open: { type: "integer", description: "1" },
                                },
                                additionalProperties: false,
                            },
                            "30": {
                                type: "object",
                                properties: {
                                    channel_id: { type: "integer", description: "30" },
                                    channel_name: { type: "string", description: '"用户裂变"' },
                                    user_level_start: { type: "string" },
                                    user_level_end: { type: "string" },
                                    order_amount: { type: "integer", description: "10" },
                                    user_tail_number: {
                                        type: "array",
                                        items: { type: "integer", description: "1" },
                                        description: "[1,2,3,4,5,6,7,8]",
                                    },
                                    identity_type: { type: "array", description: "[]" },
                                    channel_open: { type: "integer" },
                                },
                                additionalProperties: false,
                            },
                            "145": {
                                type: "object",
                                properties: {
                                    channel_id: { type: "integer", description: "145" },
                                    channel_name: { type: "string", description: '"搜索引擎"' },
                                    user_level_start: { type: "string" },
                                    user_level_end: { type: "string" },
                                    order_amount: { type: "integer", description: "10" },
                                    user_tail_number: {
                                        type: "array",
                                        items: { type: "integer", description: "1" },
                                        description: "[1,2,3,4,5,6,7,8]",
                                    },
                                    identity_type: { type: "array", description: "[]" },
                                    channel_open: { type: "integer" },
                                },
                                additionalProperties: false,
                            },
                            "1634": {
                                type: "object",
                                properties: {
                                    channel_id: { type: "integer", description: "1634" },
                                    channel_name: { type: "string", description: '"地推"' },
                                    user_level_start: { type: "string" },
                                    user_level_end: { type: "string" },
                                    order_amount: { type: "integer", description: "10" },
                                    user_tail_number: {
                                        type: "array",
                                        items: { type: "integer", description: "1" },
                                        description: "[1,2,3,4,5,6,7,8]",
                                    },
                                    identity_type: { type: "array", description: "[]" },
                                    channel_open: { type: "integer" },
                                },
                                additionalProperties: false,
                            },
                            "1640": {
                                type: "object",
                                properties: {
                                    channel_id: { type: "integer", description: "1640" },
                                    channel_name: { type: "string", description: '"应用市场"' },
                                    user_level_start: { type: "string" },
                                    user_level_end: { type: "string" },
                                    order_amount: { type: "integer", description: "10" },
                                    user_tail_number: {
                                        type: "array",
                                        items: { type: "integer", description: "1" },
                                        description: "[1,2,3,4,5,6,7,8]",
                                    },
                                    identity_type: {
                                        type: "array",
                                        items: { type: "string", description: '"个人自用"' },
                                        description: '["个人自用","网商/地摊","准备开店"]',
                                    },
                                    channel_open: { type: "integer", description: "1" },
                                },
                                additionalProperties: false,
                            },
                            "1739": {
                                type: "object",
                                properties: {
                                    channel_id: { type: "integer", description: "1739" },
                                    channel_name: { type: "string", description: '"feeds流"' },
                                    user_level_start: { type: "string" },
                                    user_level_end: { type: "string" },
                                    order_amount: { type: "integer", description: "10" },
                                    user_tail_number: { type: "array", description: "[]" },
                                    identity_type: { type: "array", description: "[]" },
                                    channel_open: { type: "integer", description: "1" },
                                },
                                additionalProperties: false,
                            },
                        },
                        additionalProperties: false,
                    },
                },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: {},
    requestFunctionName: "newUserQualityRuleSettingSave",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新客订单质检配置↗](http://yapi.yishou.com/project/128/interface/api/33589) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/newUserQualityRuleSettingSave`
 */
export const newUserQualityRuleSettingSave = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(newUserQualityRuleSettingSaveRequestConfig, requestData), ...args);
};
newUserQualityRuleSettingSave.requestConfig = newUserQualityRuleSettingSaveRequestConfig;
/**
 * 接口 [高净值用户质检配置↗](http://yapi.yishou.com/project/128/interface/api/33590) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/userNetWorthQualityRuleSettingSave`
 */
const userNetWorthQualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/userNetWorthQualityRuleSettingSave",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            rule_data: {
                type: "object",
                properties: {
                    open: { type: "integer", description: "1" },
                    user_net_worth: { type: "array", items: { type: "integer", description: "1" }, description: "[1,2,3,4,5]" },
                    level: { type: "integer", description: "1" },
                    hg_id: { type: "array", items: { type: "integer", description: "1" }, description: "[1,2,3]" },
                    user_tail_number: { type: "array", items: { type: "integer", description: "1" }, description: "[1,2,3,4]" },
                },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "导出失败的user_id 列表" } },
        required: ["file"],
    },
    requestFunctionName: "userNetWorthQualityRuleSettingSave",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [高净值用户质检配置↗](http://yapi.yishou.com/project/128/interface/api/33590) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/userNetWorthQualityRuleSettingSave`
 */
export const userNetWorthQualityRuleSettingSave = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(userNetWorthQualityRuleSettingSaveRequestConfig, requestData), ...args);
};
userNetWorthQualityRuleSettingSave.requestConfig = userNetWorthQualityRuleSettingSaveRequestConfig;
/**
 * 接口 [导入高净值用户↗](http://yapi.yishou.com/project/128/interface/api/33591) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/importUserNetWorth`
 */
const importUserNetWorthRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/importUserNetWorth",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "导入文件", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "导出错误数据" } } },
    requestFunctionName: "importUserNetWorth",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导入高净值用户↗](http://yapi.yishou.com/project/128/interface/api/33591) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/importUserNetWorth`
 */
export const importUserNetWorth = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importUserNetWorthRequestConfig, requestData), ...args);
};
importUserNetWorth.requestConfig = importUserNetWorthRequestConfig;
/**
 * 接口 [导出高净值用户数据↗](http://yapi.yishou.com/project/128/interface/api/33592) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `GET /erp/AdminSetting/exportUserNetWorth`
 */
const exportUserNetWorthRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/exportUserNetWorth",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "导出文件" } },
        required: ["file"],
    },
    requestFunctionName: "exportUserNetWorth",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导出高净值用户数据↗](http://yapi.yishou.com/project/128/interface/api/33592) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `GET /erp/AdminSetting/exportUserNetWorth`
 */
export const exportUserNetWorth = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportUserNetWorthRequestConfig, requestData), ...args);
};
exportUserNetWorth.requestConfig = exportUserNetWorthRequestConfig;
/**
 * 接口 [保存越库限制配置↗](http://yapi.yishou.com/project/128/interface/api/33593) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3408_限制不质检`
 * @请求头 `POST /erp/SurpassSummary/saveSurpassBanSetting`
 */
const saveSurpassBanSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SurpassSummary/saveSurpassBanSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["save_type", "area_restrict_quality_detach", "area_quality_limit"],
        properties: {
            save_type: {
                type: "string",
                description: "保存类型 {1:开关, 2:导入用户, 3:添加限制地区, 4:保存库存仓区占比配置, 5:移除限制地区, 6:限制地区是否限制单件分离, 8:之间分离开关,9:质检地址限制开关}",
            },
            area_restrict_quality_detach: { type: "string", description: "质检分离开关 0=关闭 1=开启" },
            area_quality_limit: { type: "string", description: "质检地区限制开关 0=关闭 1=开启" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "saveSurpassBanSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [保存越库限制配置↗](http://yapi.yishou.com/project/128/interface/api/33593) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3408_限制不质检`
 * @请求头 `POST /erp/SurpassSummary/saveSurpassBanSetting`
 */
export const saveSurpassBanSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveSurpassBanSettingRequestConfig, requestData), ...args);
};
saveSurpassBanSetting.requestConfig = saveSurpassBanSettingRequestConfig;
/**
 * 接口 [PC点货-商品撤标↗](http://yapi.yishou.com/project/128/interface/api/33611) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `采购版4.8.3`
 * @请求头 `POST /erp/takeStock/recallDbids`
 */
const recallDbidsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/takeStock/recallDbids",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbids[0]", "recall_type", "goods_no"],
        properties: {
            "dbids[0]": { type: "string", description: "dbid" },
            recall_type: { type: "string", description: "{1:有标号撤标，2:无标号撤标}" },
            goods_no: { type: "string", description: "货号，非必填" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "recallDbids",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-商品撤标↗](http://yapi.yishou.com/project/128/interface/api/33611) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `采购版4.8.3`
 * @请求头 `POST /erp/takeStock/recallDbids`
 */
export const recallDbids = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(recallDbidsRequestConfig, requestData), ...args);
};
recallDbids.requestConfig = recallDbidsRequestConfig;
/**
 * 接口 [PC点货-导入供应商留标配置↗](http://yapi.yishou.com/project/128/interface/api/34163) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/Work/importKeepTagSupplySetting`
 */
const importKeepTagSupplySettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/importKeepTagSupplySetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "importKeepTagSupplySetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-导入供应商留标配置↗](http://yapi.yishou.com/project/128/interface/api/34163) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/Work/importKeepTagSupplySetting`
 */
export const importKeepTagSupplySetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importKeepTagSupplySettingRequestConfig, requestData), ...args);
};
importKeepTagSupplySetting.requestConfig = importKeepTagSupplySettingRequestConfig;
/**
 * 接口 [PC点货-导出留标供应商列表↗](http://yapi.yishou.com/project/128/interface/api/34164) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#3082改标库存管理`
 * @请求头 `GET /erp/Work/exportKeepTagSupplySetting`
 */
const exportKeepTagSupplySettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/exportKeepTagSupplySetting",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: '"/erp/Common/export?file=csv-202209131422079094.csv"' } },
        additionalProperties: false,
    },
    requestFunctionName: "exportKeepTagSupplySetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-导出留标供应商列表↗](http://yapi.yishou.com/project/128/interface/api/34164) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#3082改标库存管理`
 * @请求头 `GET /erp/Work/exportKeepTagSupplySetting`
 */
export const exportKeepTagSupplySetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportKeepTagSupplySettingRequestConfig, requestData), ...args);
};
exportKeepTagSupplySetting.requestConfig = exportKeepTagSupplySettingRequestConfig;
/**
 * 接口 [PC点货-导出留标供应商模板↗](http://yapi.yishou.com/project/128/interface/api/34165) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#3082改标库存管理`
 * @请求头 `GET /erp/Work/exportKeepTagSupplyTemplate`
 */
const exportKeepTagSupplyTemplateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/exportKeepTagSupplyTemplate",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: '"/erp/Common/export?file=csv-202209131422079094.csv"' } },
        additionalProperties: false,
    },
    requestFunctionName: "exportKeepTagSupplyTemplate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货-导出留标供应商模板↗](http://yapi.yishou.com/project/128/interface/api/34165) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#3082改标库存管理`
 * @请求头 `GET /erp/Work/exportKeepTagSupplyTemplate`
 */
export const exportKeepTagSupplyTemplate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportKeepTagSupplyTemplateRequestConfig, requestData), ...args);
};
exportKeepTagSupplyTemplate.requestConfig = exportKeepTagSupplyTemplateRequestConfig;
/**
 * 接口 [获取快递顺丰列表↗](http://yapi.yishou.com/project/128/interface/api/34280) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3510`
 * @请求头 `POST /erp/ShippingSenderSf/getShippingSendSfList`
 */
const getShippingSendSfListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/getShippingSendSfList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "91" },
                        storehouse_name: { type: "string", description: "广州佛山仓" },
                        weight_type: { type: "string", description: "1" },
                        weight_type_formal: { type: "string", description: "小于等于 3kg" },
                        account: { type: "string", description: "广州佛山仓小于等于 3kg【0200264145】" },
                        cust_id: { type: "string", description: "0200264145 （月结单号(客户号)）" },
                        express_type: { type: "string", description: "231" },
                        express_type_formal: { type: "string", description: "陆运包裹" },
                        detail: { type: "string", description: "12312313" },
                        is_monthly: { type: "string", description: "1 ，是否月结:{1:是,2:否}" },
                        is_deleted: { type: "string", description: "2， 是否禁用:{1:否,2:是}" },
                        is_default: { type: "string", description: "1 ，是否默认:{0:否,1:是}" },
                        is_qr_code: { type: "string", description: "是否打印二维码{1:否,2:是}" },
                        province: { type: "string", description: "省", tag: "3510" },
                        city: { type: "string", description: "市", tag: "3510" },
                        district: { type: "string", description: "区", tag: "3510" },
                        sender_name: { type: "string", description: "发件人姓名", tag: "3510" },
                        sender_phone: { type: "string", description: "发件人电话", tag: "3510" },
                    },
                    required: [
                        "id",
                        "storehouse_name",
                        "weight_type",
                        "weight_type_formal",
                        "account",
                        "cust_id",
                        "express_type",
                        "express_type_formal",
                        "detail",
                        "is_monthly",
                        "is_deleted",
                        "is_default",
                        "is_qr_code",
                        "sender_phone",
                        "sender_name",
                        "district",
                        "city",
                        "province",
                    ],
                },
            },
        },
    },
    requestFunctionName: "getShippingSendSfList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取快递顺丰列表↗](http://yapi.yishou.com/project/128/interface/api/34280) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3510`
 * @请求头 `POST /erp/ShippingSenderSf/getShippingSendSfList`
 */
export const getShippingSendSfList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getShippingSendSfListRequestConfig, requestData), ...args);
};
getShippingSendSfList.requestConfig = getShippingSendSfListRequestConfig;
/**
 * 接口 [获取当前使用的快递类型↗](http://yapi.yishou.com/project/128/interface/api/34287) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/getExpressType`
 */
const getExpressTypeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/getExpressType",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        express_type: { type: "integer", description: "231" },
                        express_type_formal: { type: "string", description: '"陆运包裹"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"express_type":231,"express_type_formal":"陆运包裹"},{"express_type":247,"express_type_formal":"电商标快"},{"express_type":111,"express_type_formal":"顺丰干配"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getExpressType",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取当前使用的快递类型↗](http://yapi.yishou.com/project/128/interface/api/34287) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/getExpressType`
 */
export const getExpressType = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getExpressTypeRequestConfig, requestData), ...args);
};
getExpressType.requestConfig = getExpressTypeRequestConfig;
/**
 * 接口 [获取指定网点信息是否禁用↗](http://yapi.yishou.com/project/128/interface/api/34294) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/getSenderInfo`
 */
const getSenderInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/getSenderInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sender_id"],
        properties: { sender_id: { type: "string", description: "网点id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { is_deleted: { type: "string", description: '"1"' } },
        additionalProperties: false,
    },
    requestFunctionName: "getSenderInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取指定网点信息是否禁用↗](http://yapi.yishou.com/project/128/interface/api/34294) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/getSenderInfo`
 */
export const getSenderInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSenderInfoRequestConfig, requestData), ...args);
};
getSenderInfo.requestConfig = getSenderInfoRequestConfig;
/**
 * 接口 [新增配置↗](http://yapi.yishou.com/project/128/interface/api/34301) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3510`
 * @请求头 `POST /erp/ShippingSenderSf/addShippingSendSfConfig`
 */
const addShippingSendSfConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/addShippingSendSfConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "weight_type",
            "account_token",
            "cust_code",
            "cust_id",
            "express_type",
            "detail",
            "is_monthly",
            "is_default",
            "is_deleted",
            "is_qr_code",
            "province",
            "city",
            "district",
            "sender_name",
            "sender_phone",
        ],
        properties: {
            weight_type: { type: "string", description: "重量范围枚举:{0:默认不使用重量枚举, 1:0-3公斤 , 2:3公斤以上}" },
            account_token: { type: "string", description: "校验码" },
            cust_code: { type: "string", description: "顾客编码" },
            cust_id: { type: "string", description: "网点月结号" },
            express_type: { type: "string", description: "快递类型 231,247,111" },
            detail: { type: "string", description: "发货地址" },
            is_monthly: { type: "string", description: "是否月结:{1:是,2:否}" },
            is_default: { type: "string", description: "是否默认:{0:否,1:是}" },
            is_deleted: { type: "string", description: "是否禁用:{1:否,2:是}" },
            is_qr_code: { type: "string", description: "是否打印二维码面单:{1:否,2:是}" },
            province: { type: "string", description: "省" },
            city: { type: "string", description: "市" },
            district: { type: "string", description: "区" },
            sender_name: { type: "string", description: "发货人" },
            sender_phone: { type: "string", description: "发货人电话" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "addShippingSendSfConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新增配置↗](http://yapi.yishou.com/project/128/interface/api/34301) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3510`
 * @请求头 `POST /erp/ShippingSenderSf/addShippingSendSfConfig`
 */
export const addShippingSendSfConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(addShippingSendSfConfigRequestConfig, requestData), ...args);
};
addShippingSendSfConfig.requestConfig = addShippingSendSfConfigRequestConfig;
/**
 * 接口 [编辑顺丰网点配置↗](http://yapi.yishou.com/project/128/interface/api/34308) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3510`
 * @请求头 `POST /erp/ShippingSenderSf/editShippingSendSfConfig`
 */
const editShippingSendSfConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/editShippingSendSfConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "sender_id",
            "weight_type",
            "cust_id",
            "express_type",
            "detail",
            "is_monthly",
            "is_default",
            "is_deleted",
            "is_qr_code",
            "province",
            "city",
            "district",
            "sender_name",
            "sender_phone",
        ],
        properties: {
            sender_id: { type: "string", description: "网点id" },
            weight_type: { type: "string", description: "包裹预测重量枚举:{0:默认不使用重量枚举, 1:0-3公斤 , 2:3公斤以上}" },
            cust_id: { type: "string", description: "网点月结号" },
            express_type: { type: "string", description: "快递类型 231=陆运包裹,247=电商标快,111=顺丰干配" },
            detail: { type: "string", description: "发货地址" },
            is_monthly: { type: "string", description: "是否月结:{1:是,2:否}" },
            is_default: { type: "string", description: "是否默认:{0:否,1:是}" },
            is_deleted: { type: "string", description: "是否禁用:{1:否,2:是}" },
            is_qr_code: { type: "string", description: "是否打印二维码面单:{1:否,2:是}" },
            province: { type: "string", description: "省" },
            city: { type: "string", description: "市" },
            district: { type: "string", description: "区" },
            sender_name: { type: "string", description: "发货人" },
            sender_phone: { type: "string", description: "发货人电话" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "editShippingSendSfConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [编辑顺丰网点配置↗](http://yapi.yishou.com/project/128/interface/api/34308) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3510`
 * @请求头 `POST /erp/ShippingSenderSf/editShippingSendSfConfig`
 */
export const editShippingSendSfConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editShippingSendSfConfigRequestConfig, requestData), ...args);
};
editShippingSendSfConfig.requestConfig = editShippingSendSfConfigRequestConfig;
/**
 * 接口 [设置顺丰网点账号顾客校验码↗](http://yapi.yishou.com/project/128/interface/api/34315) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/setAccountToken`
 */
const setAccountTokenRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/setAccountToken",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sender_id", "account_token"],
        properties: {
            sender_id: { type: "string", description: "网点id" },
            account_token: { type: "string", description: "校验码" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setAccountToken",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置顺丰网点账号顾客校验码↗](http://yapi.yishou.com/project/128/interface/api/34315) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/setAccountToken`
 */
export const setAccountToken = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setAccountTokenRequestConfig, requestData), ...args);
};
setAccountToken.requestConfig = setAccountTokenRequestConfig;
/**
 * 接口 [设置顺丰网点账号顾客编码↗](http://yapi.yishou.com/project/128/interface/api/34322) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/setAccountCustCode`
 */
const setAccountCustCodeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderSf/setAccountCustCode",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sender_id", "cust_code"],
        properties: {
            sender_id: { type: "string", description: "网点id" },
            cust_code: { type: "string", description: "顾客编码" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setAccountCustCode",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置顺丰网点账号顾客编码↗](http://yapi.yishou.com/project/128/interface/api/34322) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderSf/setAccountCustCode`
 */
export const setAccountCustCode = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setAccountCustCodeRequestConfig, requestData), ...args);
};
setAccountCustCode.requestConfig = setAccountCustCodeRequestConfig;
/**
 * 接口 [获取次日发货设置配置↗](http://yapi.yishou.com/project/128/interface/api/34389) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getMorrowShipments`
 */
const getMorrowShipmentsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/getMorrowShipments",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            is_open: { type: "string", description: "是否开启 0否 1是" },
            stock_in_time: { type: "string", description: "时间节点配置" },
            scheduling_day: { type: "string", description: "排单多少天" },
            special_operation: { type: "string", description: "是否支持特殊操作 0 否 1是" },
        },
        required: [],
    },
    requestFunctionName: "getMorrowShipments",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取次日发货设置配置↗](http://yapi.yishou.com/project/128/interface/api/34389) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getMorrowShipments`
 */
export const getMorrowShipments = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getMorrowShipmentsRequestConfig, requestData), ...args);
};
getMorrowShipments.requestConfig = getMorrowShipmentsRequestConfig;
/**
 * 接口 [设置次日发货设置配置↗](http://yapi.yishou.com/project/128/interface/api/34390) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/saveMorrowShipments`
 */
const saveMorrowShipmentsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/saveMorrowShipments",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_open", "special_operation", "stock_in_time", "scheduling_day"],
        properties: {
            is_open: { type: "string", description: "是否开启配置 0 否1是" },
            special_operation: { type: "string", description: "是否支持特殊操作  0否 1是" },
            stock_in_time: { type: "string", description: "时间节点" },
            scheduling_day: { type: "string", description: "排单天数" },
        },
    },
    responseDataJsonSchema: { type: "boolean" },
    requestFunctionName: "saveMorrowShipments",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置次日发货设置配置↗](http://yapi.yishou.com/project/128/interface/api/34390) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/saveMorrowShipments`
 */
export const saveMorrowShipments = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveMorrowShipmentsRequestConfig, requestData), ...args);
};
saveMorrowShipments.requestConfig = saveMorrowShipmentsRequestConfig;
/**
 * 接口 [PC点货配置获取↗](http://yapi.yishou.com/project/128/interface/api/34533) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3048_限制不质检`
 * @请求头 `GET /erp/SurpassSummary/getSurpassSetting`
 */
const getSurpassSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SurpassSummary/getSurpassSetting",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            setting: {
                type: "object",
                properties: {
                    surpass_dabiao_open: { type: "number" },
                    wave_max_supply_num: { type: "number" },
                    wave_max_piece_num: { type: "number" },
                    cat_ids: { type: "array", items: { type: "string" } },
                    halve_include_wave_num: { type: "number" },
                    surpass_order_need_num: { type: "string" },
                    vip_hg: { type: "array", items: { type: "string" } },
                    vip_hg_max_wave_num: { type: "number" },
                    stock_hg_max_wave_num: { type: "number" },
                },
            },
            cats: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            halve_group: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            setting_ban: {
                type: "object",
                properties: {
                    is_open: { type: "string" },
                    wave_wait_out_num: { type: "string" },
                    out_storage_num: { type: "string" },
                    area_text: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { label: { type: "string" }, value: { type: "string" } },
                            required: ["label", "value"],
                        },
                    },
                    area_id: { type: "array", items: { type: "string" } },
                    area_restrict_single_detach: { type: "boolean" },
                    area_restrict_quality_detach: { type: "number" },
                    area_quality_limit: { type: "number", tag: "3048_限制不质检" },
                    dimension_limit: { type: "string" },
                },
            },
        },
    },
    requestFunctionName: "getSurpassSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货配置获取↗](http://yapi.yishou.com/project/128/interface/api/34533) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `3048_限制不质检`
 * @请求头 `GET /erp/SurpassSummary/getSurpassSetting`
 */
export const getSurpassSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSurpassSettingRequestConfig, requestData), ...args);
};
getSurpassSetting.requestConfig = getSurpassSettingRequestConfig;
/**
 * 接口 [获取快递京东列表↗](http://yapi.yishou.com/project/128/interface/api/34576) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderJd/getShippingSenderJdList`
 */
const getShippingSenderJdListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderJd/getShippingSenderJdList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["Content-Type"],
        properties: { "Content-Type": { type: "string" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string" },
                        storehouse_name: { type: "string" },
                        account: { type: "string" },
                        cust_id: { type: "string" },
                        detail: { type: "string" },
                        guarantee_value: { type: "string" },
                        guarantee_value_amount: { type: "string" },
                    },
                    required: [
                        "id",
                        "storehouse_name",
                        "account",
                        "cust_id",
                        "detail",
                        "guarantee_value",
                        "guarantee_value_amount",
                    ],
                },
            },
        },
    },
    requestFunctionName: "getShippingSenderJdList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取快递京东列表↗](http://yapi.yishou.com/project/128/interface/api/34576) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderJd/getShippingSenderJdList`
 */
export const getShippingSenderJdList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getShippingSenderJdListRequestConfig, requestData), ...args);
};
getShippingSenderJdList.requestConfig = getShippingSenderJdListRequestConfig;
/**
 * 接口 [编辑京东保价配置↗](http://yapi.yishou.com/project/128/interface/api/34578) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderJd/editShippingSenderJdConfig`
 */
const editShippingSenderJdConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ShippingSenderJd/editShippingSenderJdConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["sender_id", "cust_id", "detail", "guarantee_value", "guarantee_value_amount"],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "sender_id",
            "cust_id",
            "detail",
            "guarantee_value",
            "guarantee_value_amount",
            "sender_id",
            "cust_id",
            "detail",
            "guarantee_value",
            "guarantee_value_amount",
        ],
        properties: {
            sender_id: { type: "string", description: "网点号ID" },
            cust_id: { type: "string", description: "月结号" },
            detail: { type: "string", description: "发货地址" },
            guarantee_value: { type: "string", description: "是否保价{1:是 2:否}" },
            guarantee_value_amount: { type: "string", description: "保价金额，单位元，保留2位小数" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "editShippingSenderJdConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [编辑京东保价配置↗](http://yapi.yishou.com/project/128/interface/api/34578) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/ShippingSenderJd/editShippingSenderJdConfig`
 */
export const editShippingSenderJdConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editShippingSenderJdConfigRequestConfig, requestData), ...args);
};
editShippingSenderJdConfig.requestConfig = editShippingSenderJdConfigRequestConfig;
/**
 * 接口 [获取分播机配置↗](http://yapi.yishou.com/project/128/interface/api/36562) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `GET /erp/AdminSetting/getCutSetting`
 */
const getCutSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/getCutSetting",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            auto_collect: { type: "integer", description: "2" },
            grid_piece_num: { type: "integer", description: "30" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getCutSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取分播机配置↗](http://yapi.yishou.com/project/128/interface/api/36562) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `GET /erp/AdminSetting/getCutSetting`
 */
export const getCutSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCutSettingRequestConfig, requestData), ...args);
};
getCutSetting.requestConfig = getCutSettingRequestConfig;
/**
 * 接口 [设置分播机设置是↗](http://yapi.yishou.com/project/128/interface/api/36571) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setCutSetting`
 */
const setCutSettingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/setCutSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            auto_collect: { type: "integer", description: "1" },
            grid_piece_num: { type: "integer", description: "30" },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setCutSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [设置分播机设置是↗](http://yapi.yishou.com/project/128/interface/api/36571) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setCutSetting`
 */
export const setCutSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setCutSettingRequestConfig, requestData), ...args);
};
setCutSetting.requestConfig = setCutSettingRequestConfig;
/**
 * 接口 [PC点货 - 绑定包裹号↗](http://yapi.yishou.com/project/128/interface/api/37102) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/TakeStock/bindPackageNo`
 */
const bindPackageNoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/TakeStock/bindPackageNo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            owe_type: { type: "string", description: " 1 商家欠货 2 商家配货欠货（没返回对应参数，则默认为1）" },
        },
        required: [],
    },
    requestFunctionName: "bindPackageNo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC点货 - 绑定包裹号↗](http://yapi.yishou.com/project/128/interface/api/37102) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/TakeStock/bindPackageNo`
 */
export const bindPackageNo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(bindPackageNoRequestConfig, requestData), ...args);
};
bindPackageNo.requestConfig = bindPackageNoRequestConfig;
/**
 * 接口 [精准质检-获取PC点货拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37489) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getTallyAccurate`
 */
const getTallyAccurateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/getTallyAccurate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: { is_open: { type: "number", description: "PC点货拦截质检{1 开启 2 关闭}" } },
    },
    requestFunctionName: "getTallyAccurate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-获取PC点货拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37489) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getTallyAccurate`
 */
export const getTallyAccurate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getTallyAccurateRequestConfig, requestData), ...args);
};
getTallyAccurate.requestConfig = getTallyAccurateRequestConfig;
/**
 * 接口 [精准质检-设置PC点货拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37498) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setTallyAccurate`
 */
const setTallyAccurateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/setTallyAccurate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_open"],
        properties: { is_open: { type: "string", description: "PC点货拦截质检开关{1：开启；2关闭}" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setTallyAccurate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-设置PC点货拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37498) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setTallyAccurate`
 */
export const setTallyAccurate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setTallyAccurateRequestConfig, requestData), ...args);
};
setTallyAccurate.requestConfig = setTallyAccurateRequestConfig;
/**
 * 接口 [精准质检-获取PC质检拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37507) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getQualityAccurate`
 */
const getQualityAccurateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/getQualityAccurate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            tally_accurate: {
                type: "object",
                properties: { is_open: { type: "number", description: " 1 开启 2 关闭" } },
                description: "PC点货拦截质检配置",
            },
            quality_accurate: {
                type: "object",
                properties: { is_open: { type: "number", description: " 1 开启 2 关闭" } },
                description: "PC质检拦截质检配置",
            },
            quality_cp_exchange: {
                type: "object",
                properties: { is_open: { type: "string", description: " 1 开启 2 关闭" } },
                required: ["is_open"],
                description: "PC质检-次品区-次品退换",
            },
            quality_cp_overdue: {
                type: "object",
                properties: {
                    is_open: { type: "string", description: " 1 开启 2 关闭" },
                    overdue_day: { type: "string", description: "默认超期天数" },
                },
                description: "PC质检-次品超期配置",
                required: ["is_open", "overdue_day"],
            },
        },
        required: ["quality_cp_exchange", "quality_cp_overdue"],
    },
    requestFunctionName: "getQualityAccurate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-获取PC质检拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37507) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/getQualityAccurate`
 */
export const getQualityAccurate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getQualityAccurateRequestConfig, requestData), ...args);
};
getQualityAccurate.requestConfig = getQualityAccurateRequestConfig;
/**
 * 接口 [精准质检-设置PC质检拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37516) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setQualityAccurate`
 */
const setQualityAccurateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/setQualityAccurate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_open"],
        properties: { is_open: { type: "string", description: "1 开启 2 关闭" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setQualityAccurate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-设置PC质检拦截质检配置↗](http://yapi.yishou.com/project/128/interface/api/37516) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setQualityAccurate`
 */
export const setQualityAccurate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setQualityAccurateRequestConfig, requestData), ...args);
};
setQualityAccurate.requestConfig = setQualityAccurateRequestConfig;
/**
 * 接口 [质检次品类型列表↗](http://yapi.yishou.com/project/128/interface/api/37525) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/QualityChecking/getCpCategoryList`
 */
const getCpCategoryListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/getCpCategoryList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        cp_catid: { type: "string", description: "次品类型ID" },
                        name: { type: "string", description: "名称" },
                        pid: { type: "string", description: "父级ID" },
                        code: { type: "string", description: "code" },
                        sort: { type: "string", description: "排序" },
                        is_enable: { type: "string", description: "是否启用状态{1:是;2:否}" },
                        created_at: { type: "string" },
                        updated_at: { type: "string" },
                        p_name: { type: "string", description: "责任归属（父级名称）" },
                        is_enable_text: { type: "string", description: "是否启用状态" },
                    },
                    required: [
                        "cp_catid",
                        "name",
                        "pid",
                        "code",
                        "sort",
                        "is_enable",
                        "created_at",
                        "updated_at",
                        "p_name",
                        "is_enable_text",
                    ],
                },
            },
            p_cp_category: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        cp_catid: { type: "string", description: "父级的id" },
                        name: { type: "string", description: "父级的名称" },
                        pid: { type: "string" },
                        code: { type: "string" },
                        sort: { type: "string" },
                        is_enable: { type: "string" },
                        created_at: { type: "string" },
                        updated_at: { type: "string" },
                    },
                    required: ["cp_catid", "name", "pid", "code", "sort", "is_enable", "created_at", "updated_at"],
                },
                description: "父级的类型，用于创建时使用",
            },
        },
    },
    requestFunctionName: "getCpCategoryList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [质检次品类型列表↗](http://yapi.yishou.com/project/128/interface/api/37525) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/QualityChecking/getCpCategoryList`
 */
export const getCpCategoryList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCpCategoryListRequestConfig, requestData), ...args);
};
getCpCategoryList.requestConfig = getCpCategoryListRequestConfig;
/**
 * 接口 [质检次品类型更新启用状态↗](http://yapi.yishou.com/project/128/interface/api/37534) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/QualityChecking/updateCatEnable`
 */
const updateCatEnableRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/updateCatEnable",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["cp_catid", "is_enable"],
        properties: {
            cp_catid: { type: "string", description: "次品类型ID" },
            is_enable: { type: "string", description: "是否启用{1：是 2：否}" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateCatEnable",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [质检次品类型更新启用状态↗](http://yapi.yishou.com/project/128/interface/api/37534) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/QualityChecking/updateCatEnable`
 */
export const updateCatEnable = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateCatEnableRequestConfig, requestData), ...args);
};
updateCatEnable.requestConfig = updateCatEnableRequestConfig;
/**
 * 接口 [新增质检次品类型↗](http://yapi.yishou.com/project/128/interface/api/37543) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/QualityChecking/createCpCategory`
 */
const createCpCategoryRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/createCpCategory",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pid", "is_enable", "sort", "name"],
        properties: {
            pid: { type: "string", description: "父级ID（所属责任）" },
            is_enable: { type: "string", description: "是否启用{1是2否}" },
            sort: { type: "string", description: "排序 1-1000" },
            name: { type: "string", description: "次品类型名称" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "createCpCategory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [新增质检次品类型↗](http://yapi.yishou.com/project/128/interface/api/37543) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/QualityChecking/createCpCategory`
 */
export const createCpCategory = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createCpCategoryRequestConfig, requestData), ...args);
};
createCpCategory.requestConfig = createCpCategoryRequestConfig;
/**
 * 接口 [精准质检-导入PC点货拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37552) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/importTallyAccurateSku`
 */
const importTallyAccurateSkuRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/importTallyAccurateSku",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "导入xls文件，表头{sku}", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "array", description: "[]" },
    requestFunctionName: "importTallyAccurateSku",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-导入PC点货拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37552) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/importTallyAccurateSku`
 */
export const importTallyAccurateSku = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importTallyAccurateSkuRequestConfig, requestData), ...args);
};
importTallyAccurateSku.requestConfig = importTallyAccurateSkuRequestConfig;
/**
 * 接口 [精准质检-导出PC点货拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37561) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/exportTallyAccurateSku`
 */
const exportTallyAccurateSkuRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/exportTallyAccurateSku",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "文件下载链接" } } },
    requestFunctionName: "exportTallyAccurateSku",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-导出PC点货拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37561) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/exportTallyAccurateSku`
 */
export const exportTallyAccurateSku = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportTallyAccurateSkuRequestConfig, requestData), ...args);
};
exportTallyAccurateSku.requestConfig = exportTallyAccurateSkuRequestConfig;
/**
 * 接口 [精准质检-导入PC质检拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37570) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/importQualityAccurateSku`
 */
const importQualityAccurateSkuRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/importQualityAccurateSku",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "导入xls文件，表头{sku}", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "array", description: "[]" },
    requestFunctionName: "importQualityAccurateSku",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-导入PC质检拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37570) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/importQualityAccurateSku`
 */
export const importQualityAccurateSku = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importQualityAccurateSkuRequestConfig, requestData), ...args);
};
importQualityAccurateSku.requestConfig = importQualityAccurateSkuRequestConfig;
/**
 * 接口 [精准质检-导出PC质检拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37579) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/exportQualityAccurateSku`
 */
const exportQualityAccurateSkuRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/exportQualityAccurateSku",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "文件下载链接" } } },
    requestFunctionName: "exportQualityAccurateSku",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-导出PC质检拦截质检配置:sku维度↗](http://yapi.yishou.com/project/128/interface/api/37579) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/exportQualityAccurateSku`
 */
export const exportQualityAccurateSku = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportQualityAccurateSkuRequestConfig, requestData), ...args);
};
exportQualityAccurateSku.requestConfig = exportQualityAccurateSkuRequestConfig;
/**
 * 接口 [无数据包裹图片获取↗](http://yapi.yishou.com/project/128/interface/api/38110) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageImg`
 */
const getNoDataPackageImgRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/getNoDataPackageImg",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["no_data_package_no"],
        properties: { no_data_package_no: { type: "string", description: "无数据包裹号" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            package_img: { type: "string", description: "包裹图片" },
            no_data_package_no: { type: "string", description: "包裹号" },
            supply_name: { type: "string", description: "商家名称" },
        },
        required: ["no_data_package_no", "supply_name"],
    },
    requestFunctionName: "getNoDataPackageImg",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据包裹图片获取↗](http://yapi.yishou.com/project/128/interface/api/38110) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageImg`
 */
export const getNoDataPackageImg = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataPackageImgRequestConfig, requestData), ...args);
};
getNoDataPackageImg.requestConfig = getNoDataPackageImgRequestConfig;
/**
 * 接口 [无数据包裹图片更新↗](http://yapi.yishou.com/project/128/interface/api/38119) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/saveNoDataPackageImg`
 */
const saveNoDataPackageImgRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/saveNoDataPackageImg",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["no_data_package_no", "package_img"],
        properties: {
            no_data_package_no: { type: "string", description: "无数据包裹号" },
            package_img: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "saveNoDataPackageImg",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据包裹图片更新↗](http://yapi.yishou.com/project/128/interface/api/38119) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/NoDataGoods/saveNoDataPackageImg`
 */
export const saveNoDataPackageImg = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveNoDataPackageImgRequestConfig, requestData), ...args);
};
saveNoDataPackageImg.requestConfig = saveNoDataPackageImgRequestConfig;
/**
 * 接口 [精准质检-设置PC质检-次品超期配置↗](http://yapi.yishou.com/project/128/interface/api/38619) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setQualityCpOverdue`
 */
const setQualityCpOverdueRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/setQualityCpOverdue",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_open", "overdue_day"],
        properties: {
            is_open: { type: "string", description: "PC点货拦截质检开关{1：开启；2关闭}" },
            overdue_day: { type: "string", description: "默认超期天数" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setQualityCpOverdue",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-设置PC质检-次品超期配置↗](http://yapi.yishou.com/project/128/interface/api/38619) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setQualityCpOverdue`
 */
export const setQualityCpOverdue = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setQualityCpOverdueRequestConfig, requestData), ...args);
};
setQualityCpOverdue.requestConfig = setQualityCpOverdueRequestConfig;
/**
 * 接口 [精准质检-设置 PC质检-次品区-次品退换 配置↗](http://yapi.yishou.com/project/128/interface/api/38621) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setQualityCpExchange`
 */
const setQualityCpExchangeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/setQualityCpExchange",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_open"],
        properties: { is_open: { type: "string", description: "PC点货拦截质检开关{1：开启；2关闭}" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setQualityCpExchange",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [精准质检-设置 PC质检-次品区-次品退换 配置↗](http://yapi.yishou.com/project/128/interface/api/38621) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @请求头 `POST /erp/AdminSetting/setQualityCpExchange`
 */
export const setQualityCpExchange = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setQualityCpExchangeRequestConfig, requestData), ...args);
};
setQualityCpExchange.requestConfig = setQualityCpExchangeRequestConfig;
/**
 * 接口 [无数据商品列表-获取枚举↗](http://yapi.yishou.com/project/128/interface/api/39869) 的 **请求配置**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#4061`
 * @请求头 `POST /erp/NoDataGoods/getNoDataGoodsListFilter`
 */
const getNoDataGoodsListFilterRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/getNoDataGoodsListFilter",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            optionPg: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionOrigin: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionHandleState: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionBlpType: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
            },
            optionPgMember: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            optionIsStop: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: ["string", "number"] }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            optionDhType: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "number" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
            optionReturnMode: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "number" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
                tag: "#4061",
                description: "退回方式下来筛选",
            },
        },
    },
    requestFunctionName: "getNoDataGoodsListFilter",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据商品列表-获取枚举↗](http://yapi.yishou.com/project/128/interface/api/39869) 的 **请求函数**
 *
 * @分类 [仓库基本配置↗](http://yapi.yishou.com/project/128/interface/api/cat_2278)
 * @标签 `#4061`
 * @请求头 `POST /erp/NoDataGoods/getNoDataGoodsListFilter`
 */
export const getNoDataGoodsListFilter = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataGoodsListFilterRequestConfig, requestData), ...args);
};
getNoDataGoodsListFilter.requestConfig = getNoDataGoodsListFilterRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/warehouseConfig2278.js